export abstract class EntityFile {
  constructor(public identifier: string) {}
}

export class PartnerAvatarFile extends EntityFile {
}
